const LE_MD5_PLACE_ID_REGEX = /^le_[a-fA-F0-9]{32}$/

/**
 * Checks whether a place ID uses the legacy LE MD5 format.
 * This is narrower than checking whether a place ID is valid generally.
 */
export function isLeMd5PlaceId(placeId: string): boolean {
  return LE_MD5_PLACE_ID_REGEX.test(placeId)
}
